// /src/components/PromoBanner.jsx
import React from "react";
import styled from "styled-components";

const Card = styled.button`
  width: 100%;
  border: 0; cursor: pointer; position: relative; overflow: hidden; text-align: left;
  border-radius: 22px; min-height: 160px; padding: 22px 20px;
  background: linear-gradient(90deg,#16c8ff 0%,#10b5ff 28%,#0a98ff 55%,#0a7eff 78%,#0a6bff 100%);
  box-shadow: 0 12px 28px rgba(10,110,255,0.18);
  &:active { transform: scale(0.985); }
`;

const Rows = styled.div`
  display: grid;
  grid-template-columns: 1fr auto; /* ✅ 항상 텍스트 왼쪽 / 이미지 오른쪽 */
  align-items: center;
  height: 100%;
  column-gap: 20px;
`;

const Left = styled.div`
  display: flex; flex-direction: column; justify-content: center; color: #fff; min-width: 0;
  .top { font-weight: 800; font-size: clamp(14px, 4vw, 16px); opacity: .95; }
  .bottom { margin-top: 14px; font-weight: 900; font-size: clamp(20px, 6vw, 26px); line-height: 1.3; color: #fff; }
`;

const Right = styled.div`
  justify-self: end; text-align: right; color: #eaf6ff; white-space: nowrap;
  .tag { font-weight: 900; font-size: clamp(13px, 3.6vw, 15px); margin-bottom: 6px; }
  .price { line-height: 1; font-weight: 900; font-size: clamp(32px, 11vw, 44px); color: #ffdc7a;
    text-shadow: 0 2px 0 rgba(0,0,0,.08), 0 6px 14px rgba(0,0,0,.18); }
  .unit { margin-left: 2px; font-weight: 900; font-size: clamp(14px, 4vw, 18px); color: #ffe9ad; }
`;

/* ✅ 이미지가 항상 오른쪽 칼럼에 고정되도록 */
const ImgWrap = styled.div`
  justify-self: end; align-self: center; position: relative;
  width: ${p => p.$w || 140}px;          /* 기본 140px, prop으로 조절 가능 */
  height: ${p => p.$h || 110}px;         /* 기본 110px */
  max-width: 38vw; max-height: 30vw;    /* 작은 화면에서 과도한 비율 방지 */
  img {
    width: 100%; height: 100%; object-fit: contain; display: block;
    filter: drop-shadow(0 10px 22px rgba(0,0,0,.18));
    pointer-events: none;
  }
`;

const Shine = styled.div`
  pointer-events: none; position: absolute; inset: 0;
  background:
    radial-gradient(100% 120% at 15% 0%, rgba(255,255,255,.35) 0%, rgba(255,255,255,0) 45%),
    radial-gradient(120% 120% at 85% 100%, rgba(0,0,0,.10) 0%, rgba(0,0,0,0) 55%);
`;

export default function PromoBanner({
    leftTop = "지금 가입하고",
    leftBottom = "웰컴쿠폰 4종\\n모두 받기",
    rightTag = "24시간 유효",
    rightPrice = "9,900",
    rightUnit = "원",
    onClick,
    gradient,
    imgSrc,
    imgWidth,   // ✅ 선택: 이미지 가로(px)
    imgHeight,  // ✅ 선택: 이미지 세로(px)
}) {
    // \\n → \n 정규화 후 줄바꿈 렌더
    const normalized = String(leftBottom).replace(/\\n/g, "\n");
    const lines = normalized.split("\n");

    return (
        <Card onClick={onClick} style={gradient ? { background: gradient } : undefined}>
            <Rows>
                <Left>
                    <div className="top">{leftTop}</div>
                    <div className="bottom">
                        {lines.map((line, i) => (
                            <React.Fragment key={i}>
                                {line}{i < lines.length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </div>
                </Left>

                {imgSrc ? (
                    <ImgWrap $w={imgWidth} $h={imgHeight}>
                        <img alt="" src={imgSrc} />
                    </ImgWrap>
                ) : (
                    <Right>
                        <div className="tag">{rightTag}</div>
                        <div>
                            <span className="price">{rightPrice}</span>
                            <span className="unit">{rightUnit}</span>
                        </div>
                    </Right>
                )}
            </Rows>
            <Shine />
        </Card>
    );
}
